const moment = require("moment")

export const calcularDiferencaDatas = (dataIni, dataFim = null, tempo = "minutes") => {
    dataIni = moment(dataIni)
    dataFim = dataFim ? moment(dataFim) : moment()

    return dataFim.diff(dataIni, tempo)
}